<template>
  <div class="snappy-switch">
    <span class="snappy-switch__on">on</span>
    <input type="checkbox" :id="id" :checked="value" @change="$emit('input', $event.target.checked)" :disabled="disabled" />
    <label :for="id" class="label-info snappy-switch__label"></label>
    <span class="snappy-switch__off">off</span>
  </div>
</template>

<script>
import {generateUuid} from '../utility/generateUuid';

export default {
  name: 'snappy-switch',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      default: `switch-${generateUuid()}`,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';

.snappy-switch {
  display: flex;
  align-items: center;
  width: 60px;
  position: relative;

  & > input[type='checkbox'] {
    display: none;
  }

  & > label {
    cursor: pointer;
    height: 0px;
    position: relative;
  }

  & > label::before {
    background: rgb(0, 0, 0);
    box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.5);
    border-radius: 15px;
    content: '';
    height: 30px;
    margin-top: -15px;
    position: absolute;
    opacity: 0.3;
    transition: all 0.4s ease-in-out;
    width: 60px;
  }
  & > label::after {
    background: rgb(255, 255, 255);
    border-radius: 16px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
    content: '';
    height: 24px;
    left: 4px;
    margin-top: -8px;
    position: absolute;
    z-index: 1;
    top: -4px;
    transition: all 0.3s ease-in-out;
    width: 24px;
  }
  & > input[type='checkbox']:checked + label::before {
    background: inherit;
    opacity: 0.5;
  }
  & > input[type='checkbox']:checked + label::after {
    background: inherit;
    left: 32px;
  }
  &__label {
    background: $half-baked-color;
  }
  &__on,
  &__off {
    font-size: 16px;
    position: absolute;
    z-index: 0;
  }
  &__on {
    left: 16px;
  }

  &__off {
    right: 0;
  }
}
</style>
